import { httpAuthRequest } from '@/services'
import router from '@/router/index'

const state = {
    currentEvent: null,
    events: null,
    eventItems: [],
    types: null,
    myEvents: null,
}

const actions = {
    async getEvents({ commit }, payload) {
        let endpoint = 'events/'
        if (payload?.filter) {
            endpoint = endpoint + '?' + payload.filter
        }
        const response = await httpAuthRequest('get', endpoint)
        if (response.data.detail == "COMPULSORY_DOCUMENTS_NEEDED") {
            router.push('/my_documents')
        }

        if (response.success) {
            commit('SET_EVENTS', response.data)
            commit('SET_EVENT_ITEMS')

        }
    },
    async getMyEvents({ commit }) {
        //TODO replace by proper API call
        const response = await httpAuthRequest('get', 'events/?invited_events=true')
        if (response.success) commit('SET_MY_EVENTS', response.data)
    },

    async getTypes({ commit }) {
        const response = await httpAuthRequest('get', 'types/')
        if (response.success) commit('SET_TYPES', response.data)

        return response.success
    },

    async createEvent({ commit }, payload) {
        const response = await httpAuthRequest('post', 'events/', payload)
        if (response.success) {
            commit('SET_ALERT', { type: 'success', message: 'Event has been created successfully' })
            commit('ADD_EVENT', response.data)
        }

        else commit('SET_CREATE_EVENT_ERROR', response.data)
        return response
    },

    async editEvent({ commit }, payload) {
        const response = await httpAuthRequest('patch', `events/${payload.event_slug}/`, payload)
        if (response.success) {
            commit('SET_ALERT', { type: 'success', message: 'Event has updated' })
            // commit('UPDATE_EVENT', response.data)
        }
        else commit('SET_ALERT', { type: 'error', message: 'Something went wrong' })
        return response
    },

    async deleteEvent({ commit }, event) {
        const response = await httpAuthRequest('delete', 'events/' + event.event_slug + '/')
        if (response.success) {
            commit('SET_ALERT', { type: 'success', message: 'Event has been deleted' })
            // commit('DELETE_EVENT', event)

        }
        else commit('SET_ALERT', { type: 'error', message: 'Something went wrong' })
    },

    async eventDetails({ commit }, eventSlug) {
        const response = await httpAuthRequest('get', `events/${eventSlug}/`)
        if (response.success) commit('SET_CURRENT_EVENT', response.data)
        else commit('SET_ALERT', { type: 'error', message: 'Something went wrong' })
    }
}

const mutations = {
    SET_EVENTS(state, events) {
        state.events = events
    },
    SET_EVENT_ITEMS(state) {
        let tempArray = [];

        if (state.events?.results.length != 0) {
            for (const event of state.events.results) {

                if (event.items.length > 0) {
                    for (const item of event.items) {
                        if (tempArray.find(e => e.item_id == item.item_id) === undefined && item.item_event_type.event_type_name == 'game') {
                            tempArray.push(item);
                        }

                    }
                }

            }
        }

        state.eventItems = tempArray
    },
    SET_MY_EVENTS(state, events) {
        state.myEvents = events;
    },
    SET_TYPES(state, types) {
        state.types = types.results
    },
    RESET_STATE(state) {
        state.currentEvent = null;
        state.events = null;
        state.types = null;
        state.myEvents = null;

    },
    ADD_EVENT(state, event) {
        state.events?.results?.push(event)
    },
    UPDATE_EVENT(state, event) {
        state.myEvents = state.myEvents?.results?.filter(e => e.event_id != event.event_id)
        state.myEvents?.results?.push(event)
        // Also update the generic event list.
        state.events = state.events?.results?.filter(e => e.event_id != event.event_id)
        state.events?.results?.push(event)
    },
    DELETE_EVENT(state, event) {
        state.myEvents = state.myEvents?.results?.filter(e => e.event_id != event.event_id)
        state.events = state.events?.results?.filter(e => e.event_id != event.event_id)
    },
    SET_CURRENT_EVENT(state, event) {
        state.currentEvent = event
    }
}

export default {
    state,
    actions,
    mutations,
}
